import React from "react";
import { Link } from "gatsby";

const Footer = () => {
  const getsbyLogo = require("../images/getsby_logo_grey.svg");

  return (
    <footer className="bg-gray-100">
      <div className="container mx-auto px-8">
        <div className="w-full flex flex-col md:flex-row py-6">
          <div className="flex-1 mb-6 items-center">
            <img
              className="m-auto"
              src={getsbyLogo}
              alt="getsby"
              style={{ width: "auto", height: "56px" }}
            />
          </div>

          <div className="flex-1">
            <p className="uppercase text-gray-500 md:mb-6">Hilfe</p>
            <ul className="list-reset mb-6">
              <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                <Link
                  to="/faq"
                  className="no-underline hover:underline text-gray-800 hover:text-yellow-500"
                >
                  FAQ
                </Link>
              </li>
              {/*
                <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                  <a
                    href="mailto:support@gets.by"
                    className="no-underline hover:underline text-gray-800 hover:text-yellow-500"
                  >
                    Hilfe & Support
                  </a>
                </li>
              */}
            </ul>
          </div>
          <div className="flex-1">
            <p className="uppercase text-gray-500 md:mb-6">Rechtliches</p>
            <ul className="list-reset mb-6">
              <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                <Link
                  to="/gtc"
                  className="no-underline hover:underline text-gray-800 hover:text-yellow-500"
                >
                  AGBs
                </Link>
              </li>
              <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                <Link
                  to="/privacy-policy"
                  className="no-underline hover:underline text-gray-800 hover:text-yellow-500"
                >
                  Datenschutzerklärung
                </Link>
              </li>
            </ul>
          </div>
          <div className="flex-1">
            <p className="uppercase text-gray-500 md:mb-6">Social Media</p>
            <ul className="list-reset mb-6">
              <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                <a
                  href="https://www.facebook.com/getsbyapp.austria/"
                  className="no-underline hover:underline text-gray-800 hover:text-yellow-500"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook
                </a>
              </li>
              <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                <a
                  href="https://www.instagram.com/getsbyapp/"
                  className="no-underline hover:underline text-gray-800 hover:text-yellow-500"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Instagram
                </a>
              </li>
              <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                <a
                  href="https://www.linkedin.com/company/getsbyapp/"
                  className="no-underline hover:underline text-gray-800 hover:text-yellow-500"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Linkedin
                </a>
              </li>
            </ul>
          </div>
          <div className="flex-1">
            <p className="uppercase text-gray-500 md:mb-6">Unternehmen</p>
            <ul className="list-reset mb-6">
              <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                <Link
                  to="/imprint"
                  className="no-underline hover:underline text-gray-800 hover:text-yellow-500"
                >
                  Impressum
                </Link>
              </li>
              <li className="mt-2 inline-block mr-2 md:block md:mr-0">
                <a
                  href="mailto:office@gets.by"
                  className="no-underline hover:underline text-gray-800 hover:text-yellow-500"
                >
                  Kontakt
                </a>
              </li>
            </ul>
          </div>
        </div>
        <p className="py-4 text-center text-gray-500">
          © {new Date().getFullYear()} getsby
        </p>
      </div>
    </footer>
  );
};

export default Footer;
